import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/RapidElearningLogDetails/api/rapidElearningLogDetailsService'
import { RapidElearningLogDetailsState, ApiRapidElearningLogDetailsResponse } from './types'

const initialState: RapidElearningLogDetailsState = {
  data: {},
}

const rapidElearningLogDetailsSlice = createSlice({
  name: 'activityLogRapidElearningLogDetails',
  initialState,
  reducers: {
    dataLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiRapidElearningLogDetailsResponse>>
    ) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = rapidElearningLogDetailsSlice.actions

export default rapidElearningLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
